import './style/index.less';
import MsgTargetEditPane from './MsgTargetEditPane';

export default MsgTargetEditPane;
